module.exports = __webpack_public_path__ + "static/media/ListView.f848a37c.svg";